<template>
  <div @mouseover="mouseOver" @mouseleave="mouseLeave">
    <div>Student Faculty Ratio</div>
    <div>
      <div v-if="active">
        <apexchart width="400" type="donut" :options="chartOptions" :series="series"></apexchart>
      </div>
      <div v-else class="content">
        <img src="../assets/PQC1.jpg">
        <div class="text"><h1>Student Faculty Ratio</h1></div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  data: function() {
   return {
    active: false,
    series: [11.1, 88.89],
    chartOptions: {
      labels: ['Faculty', 'Student'],
      legend: {
        show: false
      },
      chart: {
        type: 'donut',
      },
        stroke: {
        colors: ['#fff']
      },
        fill: {
        opacity: 0.8
      },
        responsive: [{
          breakpoint: 480,
          options: {
          chart: {
            width: 200
          },
        }
      }]
    },
   }      
  },
  methods: {
    mouseOver: function() {
      this.active = true;
    },
    mouseLeave: function() {
      this.active = false;
    }
  },
};
</script>
<style scoped>
.text {
  position: absolute;
  top: 50%;
  left: 50%;
  transform: translate(-50%, -50%);
  color: white;
}

.content {
  text-align: center;
  position: relative;
}

.img {
  object-fit:cover;
}
</style>